export const DEFAULT_PUBLIC_URL = '/';
function getBuildTimePublicUrl() {
    try {
        return process.env.PUBLIC_URL || undefined;
    }
    catch {
        return undefined;
    }
}
export function getPublicUrl() {
    const globals = globalThis;
    return (globals.PUBLIC_URL ||
        globals.config?.path ||
        getBuildTimePublicUrl() ||
        DEFAULT_PUBLIC_URL);
}
function getOrigin() {
    const { location } = globalThis;
    return location ? `${location.protocol}//${location.host}` : undefined;
}
export default function resolveApplicationUrl(path = '') {
    const publicUrl = getPublicUrl();
    const base = publicUrl.endsWith('/') ? publicUrl : `${publicUrl}/`;
    const origin = getOrigin();
    try {
        return new URL(path, origin ? new URL(base, origin) : new URL(base)).href;
    }
    catch {
        return path;
    }
}
